import XButton from "../common/XButton";
import RenderIf from "../render-if/Renderif";
import {
   tooltipActionsClasses,
   tooltipClasses,
   tooltipContentClasses,
   tooltipFooterClasses,
   tooltipHintClasses,
   tooltipProgressClasses,
   tooltipSkipClasses,
   tooltipSkipStopClasses,
   tooltipTitleClasses,
} from "./tourClasses";

const EXIT_LABEL = "Exit tour";
const BACK_LABEL = "Back";
const NEXT_LABEL = "Next";
const DONE_LABEL = "Done";
const SKIP_STOP_LABEL = "Skip this one";

const TourTooltip = ({
   backProps,
   index,
   isLastStep,
   primaryProps,
   size,
   skipProps,
   step,
   tooltipProps,
   isBlocked = false,
   blockedHint = null,
   onSkipStop = null,
}) => (
   <div className={tooltipClasses} {...tooltipProps}>
      <RenderIf shouldRender={Boolean(step.title)}>
         <h2 className={tooltipTitleClasses}>{step.title}</h2>
      </RenderIf>

      <div className={tooltipContentClasses}>{step.content}</div>

      <RenderIf shouldRender={isBlocked && Boolean(blockedHint)}>
         <div className={tooltipHintClasses}>
            <span>{blockedHint}</span>

            <RenderIf shouldRender={Boolean(onSkipStop)}>
               <button type="button" className={tooltipSkipStopClasses} onClick={onSkipStop}>
                  {SKIP_STOP_LABEL}
               </button>
            </RenderIf>
         </div>
      </RenderIf>

      <div className={tooltipFooterClasses}>
         <button type="button" className={tooltipSkipClasses} {...skipProps}>
            {EXIT_LABEL}
         </button>

         <div className={tooltipActionsClasses}>
            <span className={tooltipProgressClasses}>
               {index + 1} of {size}
            </span>

            <RenderIf shouldRender={index > 0}>
               <XButton variant="outlinePrimary" {...backProps}>
                  {BACK_LABEL}
               </XButton>
            </RenderIf>

            <XButton variant="primary" {...primaryProps} disabled={isBlocked}>
               {isLastStep ? DONE_LABEL : NEXT_LABEL}
            </XButton>
         </div>
      </div>
   </div>
);

export default TourTooltip;
